import { UpdateControlMetadata } from '../validators/helpers';
import { MemoizedSelector } from '@ngrx/store';
import {
  Unboxed,
  FormGroupState
} from 'ngrx-forms';

export function Disabled<FormValue>(selector?: MemoizedSelector<any, boolean> | ((value: Unboxed<FormValue>, state: FormGroupState<FormValue>) => boolean)) {
  return function (target: any, propertyKey: string) {
    if (selector) {
      if (typeof selector === 'function') {
        UpdateControlMetadata(target, propertyKey, { disabledFunction: selector });
      } else {
        UpdateControlMetadata(target, propertyKey, { disabledSelector: selector });
      }
    } else {
      UpdateControlMetadata(target, propertyKey, { disabled: true });
    }
  }
}
